import { IContactValues } from "../types"

const pickContactValues = (obj: IContactValues & any): IContactValues => {
  const { company, email, firstname, lastname, phone } = obj
  return {
    company,
    email,
    firstname,
    lastname,
    phone,
  }
}

export { pickContactValues }
